import { ComboboxDefaultState } from '@cp-shared-19/frontend-ui';
import { Combobox, FormField } from '@vwfs-bronson/bronson-react';
import { useField } from 'formik';
import React, { useCallback, useEffect, useState } from 'react';
import { ComboboxOption } from 'types/bronson-react';

export const SelectField: React.FC<{
    testId: string;
    name: string;
    label: string;
    options: ComboboxOption[];
    visible: boolean;
    defaultState?: ComboboxDefaultState;
}> = ({ testId, label, name, options, visible, defaultState }) => {
    const [field, , helpers] = useField(name);
    const [selectedItem, setSelectedItem] = useState<{ value: ComboboxOption[] }>({
        value: [
            {
                value: options.find((o) => o.key === field.value)?.value || field.value,
                key: field.value,
            },
        ],
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onChange = useCallback((values: any) => {
        setSelectedItem({ value: [values[0]] });
        helpers.setValue(values[0]?.key);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const comboDefaultState = defaultState
        ? defaultState
        : {
              value: [
                  {
                      value: options.find((o) => o.key === field.value)?.value || field.value,
                      key: field.value,
                  },
              ],
          };

    useEffect(() => {
        setSelectedItem({
            value: [
                {
                    key: field.value,
                    value: options.find((o) => o.key === field.value)?.value || field.value,
                },
            ],
        });
    }, [field.value]); // eslint-disable-line react-hooks/exhaustive-deps

    if (!visible) return null;

    const generateOptions = () => {
        return options.map((filter) => ({
            key: filter.key,
            value: filter.value,
        }));
    };

    return (
        <FormField type="select" testId={testId} id={name} labelText={label} noFloatingLabel>
            <Combobox
                key={options.length}
                name={name}
                testId={`${testId}-combo`}
                onChange={onChange}
                value={selectedItem.value}
                defaultState={comboDefaultState}
                className="c-form-field--no-floating"
                options={generateOptions()}
            ></Combobox>
        </FormField>
    );
};
